export default __webpack_public_path__ + "static/media/breadcumb-bg.3ac35685.jpg";